module.exports = __webpack_public_path__ + "20e30f2668b629d0856d52e2c74f286e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/banner-bg01.png
// module id = 241
// module chunks = 3